import { Controller } from "@hotwired/stimulus";

export class EducationExperienceModalController extends Controller {
  static targets = [
    "form",
    "modal",
    "schoolName",
    "startDate",
    "endDate",
    "career",
    "speciality",
    "currentEducation",
  ];

  static values = {
    id: String,
    schoolName: String,
    startDate: String,
    endDate: String,
    career: String,
    speciality: String,
    currentEducation: Boolean,
  };

  connect() {
    this.formTarget.action = `/users/edit-education-experience/${this.idValue}`;
  }

  open(event) {
    this.schoolNameTarget.value = this.schoolNameValue;
    this.startDateTarget.value = this.startDateValue;
    this.endDateTarget.value = this.endDateValue;
    this.careerTarget.value = this.careerValue;
    this.specialityTarget.value = this.specialityValue;
    this.currentEducationTarget.checked = this.currentEducationValue;
    if (this.currentEducationTarget.checked) {
      this.endDateTarget.setAttribute("disabled", "");
    }

    this.modalTarget.showModal();
  }

  close(event) {
    this.modalTarget.close();
  }

  submit(event) {
    event.preventDefault();
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity();
      return;
    } else {
      this.formTarget.requestSubmit();
      return;
    }
  }
}
